import { ReactNode } from "react";
import { ContextProvider } from "./context";

export function FirebaseProvider({ children }: { children: ReactNode }) {
  return <ContextProvider>{children}</ContextProvider>;
}
